import { Directive, ElementRef, Host, OnInit } from '@angular/core';
import { MuuriDirective } from './muuri.directive'

@Directive({
  selector: '[appMuuriItems]'
})
export class MuuriItemsDirective implements OnInit {
  constructor(@Host() private tileGrid: MuuriDirective, private elRef: ElementRef) {}

  ngOnInit(): void {
      this.tileGrid.addItem(this.elRef.nativeElement);
  }
}
